import React from "react";
import { DocumentosSetoriaisProvider } from "./context/documentos-setoriais-context";
import { DocumentosSetoriais } from "./documentos-setoriais";
import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory";

const DocumentosSetoriaisFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle={"Documentos Setoriais"}>
            <DocumentosSetoriaisProvider>
                <DocumentosSetoriais />
            </DocumentosSetoriaisProvider>
        </BaseInternalFormFactory>
    );
};

export default DocumentosSetoriaisFactory;
